import { Box, Checkbox, CircularProgress, Container, FormControlLabel, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

class ConsultaCalificaciones extends Component {
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            notificaciones: null,
            errores: null,
            consultaRealizada: false,
            consultaEspecifica: false,
            numeroNombre: [],
            lugaresTrabajo: [],
            ubicacionesCentral: [],
            serieBase: [],
            cargos: [],
            grados: [],
            escalafones: [],
            consultaCalificacion: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                anio: '',
            },
            datosConsulta: [],
            datosConsultaEspe: {},
        }
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejoEnvioConsulta = this.manejoEnvioConsulta.bind(this);
        this.manejarConsultaEspecifica = this.manejarConsultaEspecifica.bind(this);
        this.manejarAtrasCon = this.manejarAtrasCon.bind(this);
        this.manejarAtras = this.manejarAtras.bind(this);
        this.manejarCambiosCalificacion = this.manejarCambiosCalificacion.bind(this);
        this.calcularPromedio = this.calcularPromedio.bind(this);
        this.manejarEnvioCalificacion = this.manejarEnvioCalificacion.bind(this);
    }
    async componentDidMount(){
        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });

        const datosEscalafones = await fetch(`${Constantes.RUTA_API}/obtener_escalafones.php`);
        const datoEscalafon = await datosEscalafones.json();
        this.setState({
            escalafones: datoEscalafon,
        });

        const datosGrados = await fetch(`${Constantes.RUTA_API}/obtener_grados.php`);
        const datoGrado = await datosGrados.json();
        this.setState({
            grados: datoGrado,
        });

        const datosCargos = await fetch(`${Constantes.RUTA_API}/obtener_cargos.php`);
        const datoCargo = await datosCargos.json();
        this.setState({
            cargos: datoCargo,
        });

        const serie = await fetch(`${Constantes.RUTA_API}/obtener_series.php`);
        const datoSerie = await serie.json();
        this.setState({
            serieBase: datoSerie,
        });

        const lugarCentral = await fetch(`${Constantes.RUTA_API}/obtener_ubicacionesCentral.php`);
        const datoLugarCentral = await lugarCentral.json();
        this.setState({
            ubicacionesCentral: datoLugarCentral,
        });

        const lugar = await fetch(`${Constantes.RUTA_API}/obtener_lugaresTrabajo.php`);
        const datoLugar = await lugar.json();
        this.setState({
            lugaresTrabajo: datoLugar,
        });
    }
    render(){
        return (
            <>
                <Container>
                <h3>Calificaciones</h3>
                    {this.state.loading
                    ?
                        <div style={{placeItems: 'center'}}>
                            <Box sx={{alignItems: 'center'}}>
                                <CircularProgress/>
                            </Box>
                        </div>
                    :
                        null
                    }
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    <br/>
                    {this.state.consultaRealizada || this.state.consultaEspecifica
                    ?
                        null
                    :
                        <Container>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Numero Funcionario</StyledTableCell>
                                            <StyledTableCell>Nombre Funcionario</StyledTableCell>
                                            <StyledTableCell>Año</StyledTableCell>
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <StyledTableRow>
                                            <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='numeroFuncionario' value={this.state.consultaCalificacion.numeroFuncionario} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                            <StyledTableCell>{this.state.consultaCalificacion.nombreFuncionario}</StyledTableCell>
                                            <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='anio' value={this.state.consultaCalificacion.anio} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                            <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejoEnvioConsulta()}>Consultar</button></StyledTableCell>
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Container>
                    }
                    {this.state.consultaRealizada
                    ?
                        <Container>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                <Table sx={{minWidth: 700}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Número Funcionario</StyledTableCell>
                                            <StyledTableCell>Nombre Funcionario</StyledTableCell>
                                            <StyledTableCell>Año</StyledTableCell>
                                            <StyledTableCell>Promedio Total</StyledTableCell>
                                            <StyledTableCell>Calificación Realizada</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.state.datosConsulta.map((dato,index) => (
                                            <StyledTableRow key={index}>
                                                {dato.estadoCalificacion === 'SI'
                                                ?
                                                    <StyledTableCell>{dato.numeroFuncionario}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.numeroFuncionario}</StyledTableCell>
                                                }
                                                {dato.estadoCalificacion === 'SI'
                                                ?
                                                    <StyledTableCell>{dato.nombreFuncionario}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.nombreFuncionario}</StyledTableCell>
                                                }
                                                {dato.estadoCalificacion === 'SI'
                                                ?
                                                    <StyledTableCell>{dato.anio}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.anio}</StyledTableCell>
                                                }
                                                {dato.estadoCalificacion === 'SI'
                                                ?
                                                    <StyledTableCell>{dato.puntaje}</StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown'}}>{dato.puntaje}</StyledTableCell>
                                                }
                                                {dato.estadoCalificacion === 'SI'
                                                ?
                                                    <StyledTableCell><button className="btn btn-blue mx-2" type='button' onClick={() => this.manejarConsultaEspecifica(dato)}>Consultar/Modificar</button></StyledTableCell>
                                                :
                                                    <StyledTableCell style={{backgroundColor: 'brown', textAlign: 'center'}}>NO</StyledTableCell>
                                                }
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <button className="btn btn-outline-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtrasCon}>Volver</button>
                        </Container>
                    :
                        null
                    }
                    {this.state.consultaEspecifica
                    ?
                        <Container>
                            <fieldset>
                                <legend>Datos Funcionario</legend>
                                <Box sx={{ flexGrow: 1}}>
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={2.1}>
                                            <Item>Número Funcionario</Item>
                                        </Grid>
                                        <Grid item xs={3}>
                                            {this.state.datosConsultaEspe.numeroFuncionario}
                                        </Grid>
                                        <Grid item xs={1}>
                        
                                        </Grid>
                                        <Grid item xs={2.1}>
                                            <Item>Nombre Funcionario</Item>
                                        </Grid>
                                        <Grid item xs={3}>
                                            {this.state.datosConsultaEspe.nombreFuncionario !== ''
                                            ?
                                                <Item>{this.state.datosConsultaEspe.nombreFuncionario}</Item>
                                            :
                                                null
                                            }
                                        </Grid>
                                        <Grid item xs={2.1}>
                                            <Item>Escalafón</Item>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='escalafon'  value={this.state.datosConsultaEspe.escalafon} onChange={this.manejarCambiosCalificacion}>
                                                <option value=''>ESCALAFON</option>
                                                {this.state.escalafones.map((name) =>
                                                    <option
                                                    key={name.idEscalafon}
                                                    value={name.idEscalafon}
                                                    >{name.descripcion}</option>
                                                    )}
                                            </select>
                                        </Grid>
                                        <Grid item xs={1}>
                        
                                        </Grid>
                                        <Grid item xs={2.1}>
                                            <Item>Serie</Item>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='serie' value={this.state.datosConsultaEspe.serie} onChange={this.manejarCambiosCalificacion} >
                                                <option value={''}>SERIE CONCURSO</option>
                                                {this.state.serieBase.map((name) =>
                                                    <option
                                                    key={name.idSerie}
                                                    value={name.idSerie}
                                                    >{name.descripcion}</option>
                                                )}
                                            </select>
                                        </Grid>
                                        <Grid item xs={2.1}>
                                            <Item>Cargo</Item>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='cargo'  value={this.state.datosConsultaEspe.cargo} onChange={this.manejarCambiosCalificacion}>
                                                <option value=''>CARGO</option>
                                                {this.state.cargos.map((name) =>
                                                    <option
                                                    key={name.idCargo}
                                                    value={name.idCargo}
                                                    >{name.descripcion}</option>
                                                    )}
                                            </select>
                                        </Grid>
                                        <Grid item xs={1}>
                        
                                        </Grid>
                                        <Grid item xs={2.1}>
                                            <Item>Grado</Item>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='grado'  value={this.state.datosConsultaEspe.grado} onChange={this.manejarCambiosCalificacion}>
                                                <option value=''>GRADO</option>
                                                {this.state.grados.map((name) =>
                                                    <option
                                                    key={name.idGrado}
                                                    value={name.idGrado}
                                                    >{name.descripcion}</option>
                                                    )}
                                            </select>
                                        </Grid>
                                        <Grid item xs={2.1}>
                                            <Item>Ubicación</Item>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}}  id="lugar" value={this.state.datosConsultaEspe.lugar} onChange={this.manejarCambiosCalificacion}>
                                                <option value={''}>LUGAR</option>
                                                {this.state.lugaresTrabajo.map((name) =>
                                                    <option
                                                    key={name.idLugaresTrabajo}
                                                    value={name.idLugaresTrabajo}
                                                    >{name.lugar}</option>
                                                    )}
                                            </select>
                                        </Grid>
                                        <Grid item xs={1}>
                        
                                        </Grid>
                                        {this.state.datosConsultaEspe.lugar == '0'
                                        ?
                                            <Grid item xs={2.1}>
                                                <Item>Ubicación Central</Item>
                                            </Grid>
                                        :
                                            null
                                        }
                                        {this.state.datosConsultaEspe.lugar == '0'
                                        ?
                                            <Grid item xs={3}>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}}  id="lugarCentral" value={this.state.datosConsultaEspe.lugarCentral} onChange={this.manejarCambiosCalificacion}>
                                                    <option value={''}>LUGAR CENTRAL</option>
                                                    {this.state.ubicacionesCentral.map((name) =>
                                                        <option
                                                        key={name.idUbicacionesCentral}
                                                        value={name.idUbicacionesCentral}
                                                        >{name.descripcion}</option>
                                                        )}
                                                </select>
                                            </Grid>
                                        :
                                            null
                                        }
                                        <Grid item xs={2.1}>
                                            <Item>Supervisión</Item>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='conSupervision' value={this.state.datosConsultaEspe.conSupervision} onChange={this.manejarCambiosCalificacion}>
                                                <option value={''}>SUPERVISION</option>
                                                <option value={0}>NO</option>
                                                <option value={1}>SI</option>
                                            </select>
                                        </Grid>
                                        {this.state.datosConsultaEspe.lugar == '0'
                                        ?
                                            <Grid item xs={1}>
                        
                                            </Grid>
                                        :
                                            null
                                        }
                                        <Grid item xs={2.1}>
                                            <Item>Año</Item>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='anio' value={this.state.datosConsultaEspe.anio} onChange={this.manejarCambiosCalificacion} type="number" />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </fieldset>
                            <br/>
                            <br/>
                            <fieldset>
                                <legend>EVALUACION DE DESEMPEÑO</legend>
                                <fieldset>
                                    <legend>RENDIMIENTO Y CALIDAD</legend>
                                    <p>Puntajes del 1 al 5</p>
                                    <Box sx={{ flexGrow: 1}}>
                                        <Grid container spacing={2} rowSpacing={1}>
                                            <Grid item xs={2.1}>
                                                <Item>Cantidad de trabajo</Item>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='cantidadTrabajo' value={this.state.datosConsultaEspe.cantidadTrabajo} onChange={this.manejarCambiosCalificacion} type="number" />
                                            </Grid>
                                            <Grid item xs={1}>

                                            </Grid>
                                            <Grid item xs={2.1}>
                                                <Item>Calidad de la labor realizada</Item>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='calidadLaboral' value={this.state.datosConsultaEspe.calidadLaboral} onChange={this.manejarCambiosCalificacion} type="number" />
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                <Item>Procupación por el servicio o usuario</Item>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='preocupacionServicio' value={this.state.datosConsultaEspe.preocupacionServicio} onChange={this.manejarCambiosCalificacion} type="number" />
                                            </Grid>
                                            <Grid item xs={6}>

                                            </Grid>
                                            <Grid item xs={4}>
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                <Item>Promedio</Item>
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                {this.state.datosConsultaEspe.promedioRC}
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </fieldset>
                                <fieldset>
                                    <legend>CONDICIONES PERSONALES</legend>
                                    <p>Puntajes del 1 al 5</p>
                                    <Box sx={{ flexGrow: 1}}>
                                        <Grid container spacing={2} rowSpacing={1}>
                                            <Grid item xs={2.1}>
                                                <Item>Conocimiento del trabajo</Item>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='conocimientoTrabajo' value={this.state.datosConsultaEspe.conocimientoTrabajo} onChange={this.manejarCambiosCalificacion} type="number" />
                                            </Grid>
                                            <Grid item xs={1}>

                                            </Grid>
                                            <Grid item xs={2.1}>
                                                <Item>Interés por el trabajo</Item>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='interesTrabajo' value={this.state.datosConsultaEspe.interesTrabajo} onChange={this.manejarCambiosCalificacion} type="number" />
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                <Item>Capacidad para realizar trabajos en grupo</Item>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='capacidadTrabajo' value={this.state.datosConsultaEspe.capacidadTrabajo} onChange={this.manejarCambiosCalificacion} type="number" />
                                            </Grid>
                                            <Grid item xs={1}>

                                            </Grid>
                                            <Grid item xs={2.1}>
                                                <Item>relaciones interpersonales</Item>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='relacionesInterpersonales' value={this.state.datosConsultaEspe.relacionesInterpersonales} onChange={this.manejarCambiosCalificacion} type="number" />
                                            </Grid>
                                            <Grid item xs={4}>
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                <Item>Promedio</Item>
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                {this.state.datosConsultaEspe.promedioCP}
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </fieldset>
                                <fieldset>
                                    <legend>COMPORTAMIENTO DEL FUNCIONARIO</legend>
                                    <p>Puntajes del 1 al 5</p>
                                    <Box sx={{ flexGrow: 1}}>
                                        <Grid container spacing={2} rowSpacing={1}>
                                            <Grid item xs={2.1}>
                                                <Item>Asistencia y puntualidad</Item>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='asistenciaPuntualidad' value={this.state.datosConsultaEspe.asistenciaPuntualidad} onChange={this.manejarCambiosCalificacion} type="number" />
                                            </Grid>
                                            <Grid item xs={1}>

                                            </Grid>
                                            <Grid item xs={2.1}>
                                                <Item>Cumplimiento de normas e instrucciones</Item>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='cumplimientoNormas' value={this.state.datosConsultaEspe.cumplimientoNormas} onChange={this.manejarCambiosCalificacion} type="number" />
                                            </Grid>
                                            <Grid item xs={4}>
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                <Item>Promedio</Item>
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                {this.state.datosConsultaEspe.promedioCDF}
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </fieldset>
                                <fieldset>
                                    <legend>APTITUDES EN CARGOS DE SUPERVISION Y RESPONSABILIDAD</legend>
                                    <p>Puntajes del 1 al 5</p>
                                    <Box sx={{ flexGrow: 1}}>
                                        <Grid container spacing={2} rowSpacing={1}>
                                            <Grid item xs={2.1}>
                                                <Item>Supervisión</Item>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='supervision' value={this.state.datosConsultaEspe.supervision} onChange={this.manejarCambiosCalificacion} type="number" />
                                            </Grid>
                                            <Grid item xs={1}>

                                            </Grid>
                                            <Grid item xs={2.1}>
                                                <Item>Logro de metas</Item>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='logroMetas' value={this.state.datosConsultaEspe.logroMetas} onChange={this.manejarCambiosCalificacion} type="number" />
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                <Item>Iniciativa</Item>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='iniciativa' value={this.state.datosConsultaEspe.iniciativa} onChange={this.manejarCambiosCalificacion} type="number" />
                                            </Grid>
                                            <Grid item xs={1}>

                                            </Grid>
                                            <Grid item xs={2.1}>
                                                <Item>Compromiso</Item>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='compromiso' value={this.state.datosConsultaEspe.compromiso} onChange={this.manejarCambiosCalificacion} type="number" />
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                <Item>Responsabilidad</Item>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='responsabilidad' value={this.state.datosConsultaEspe.responsabilidad} onChange={this.manejarCambiosCalificacion} type="number" />
                                            </Grid>
                                            <Grid item xs={4}>
                                            </Grid>
                                            <Grid item xs={4}>
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                <Item>Promedio</Item>
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                {this.state.datosConsultaEspe.aptitudesCSR}
                                            </Grid>
                                            <Grid item xs={4}>

                                            </Grid>
                                            <Grid item xs={2.1}>
                                                <Item>Promedio Total</Item>
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                {this.state.datosConsultaEspe.puntaje}
                                            </Grid>
                                            <Grid item xs={4}>

                                            </Grid>
                                            <Grid item xs={2.1}>
                                                <Item>Observaciones</Item>
                                            </Grid>
                                            <Grid item xs={3}>

                                            </Grid>
                                            <Grid item xs={12}>
                                            </Grid>
                                        </Grid>
                                        <textarea style={{border: "2px solid #D6EAF8", width: "100%"}} id='comentarios' value={this.state.datosConsultaEspe.comentarios} onChange={this.manejarCambiosCalificacion}/>
                                    </Box>
                                </fieldset>
                            </fieldset>
                            <br/>
                            {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                            {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                            <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtras}>Volver</button>
                            <button className="btn btn-outline-success mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioCalificacion}>Enviar</button>
                            <br/>
                            <br/>
                        </Container>
                    :
                        null
                    }
                </Container>
            </>
        )
    }

    async calcularPromedio(valor, clave){
        let promedio = 0;
        const cargaUtil = JSON.stringify([this.state.datosConsultaEspe, valor, clave]);

        const control = await fetch(`${Constantes.RUTA_API}/calcular_promedio.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState(state => {
            const calificacionActu = state.datosConsultaEspe;
            calificacionActu['puntaje'] = res[0];
            calificacionActu['promedioRC'] = res[1];
            calificacionActu['promedioCP'] = res[2];
            calificacionActu['promedioCDF'] = res[3];
            calificacionActu['aptitudesCSR'] = res[4];
            return{
                datosConsultaEspe: calificacionActu,
            };
        })
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
            consultaRealizada: false,
        });
        this.setState(state => {
            const numFunActualizado = state.consultaCalificacion;
            numFunActualizado[clave] = valor;
            
            if((clave === 'numeroFuncionario') && (valor !== '') ){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    numFunActualizado['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    numFunActualizado['nombreFuncionario'] = '';
                }
                });
            }else if((clave === 'nombreFuncionario') && (valor === '')){
                numFunActualizado['nombreFuncionario'] = '';
            }
            
            return{
                consultaCalificacion: numFunActualizado,
            };
        });
    }

    async manejoEnvioConsulta(){
        this.setState({
            errores: null,
            notificaciones: null,
            loading: false,
            consultaRealizada: false,
        })
        if((this.state.consultaCalificacion.numeroFuncionario !== '') && (this.state.consultaCalificacion.nombreFuncionario === '')){
            this.setState({
                errores: 'Debe ingresar un número de funcionario valido',
            })
        }else if(this.state.consultaCalificacion.anio === ''){
            this.setState({
                errores: 'Debe ingresar el año de la consulta',
            })
        }else{
            this.setState({
                loading: true,
                errores: null,
                notificaciones: null,
            });
            const cargaUtil = JSON.stringify([this.state.consultaCalificacion, sessionStorage.lugar, sessionStorage.lugarCentral, sessionStorage.numeroFuncionarioAsociado]);
            const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_calificacionesJefes.php`,{
                method: 'POST',
                body: cargaUtil,
            })

            const exito = await respuesta.json();

            this.setState({
                errores: exito[0],
                loading: false,
            })
            if(exito[0] === 'ok'){
                this.setState({
                    datosConsulta: exito[1],
                    errores: null,
                    notificaciones: null,
                    consultaRealizada: true,
                })
            }
        }
    }

    manejarConsultaEspecifica(dato){
        this.setState({
            consultaEspecifica: true,
            datosConsultaEspe: dato,
            notificaciones: null,
            errores: null,
            consultaRealizada: false,
        });
    }

    manejarAtrasCon(e){
        e.preventDefault();
        this.setState({
            consultaEspecifica: false,
            consultaRealizada: false,
            consultaFuncionario: false,
            datosConsultaEspe: {},
            datosConsulta: [],

            consultaCalificacion: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                anio: '',
            },
        })
    }

    manejarAtras(e){
        e.preventDefault();
        this.setState({
            consultaEspecifica: false,
            consultaRealizada: true,
            datosConsultaEspe: {},
            errores: null,
            notificaciones: null,
        })
    }

    manejarCambiosCalificacion(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.calcularPromedio(valor, clave);
        this.setState({
            errores: null,
            notificaciones: null,
            calificaciones: null,
            calificacionesTribunal: null,
            datosMov: null,
            //calificacionesJefe: null,
            checkedListFuncionario: {
                ambos: false,
                soloJefe: true,
                soloTribunal: false,
            },
        })
        this.setState(state => {
            const calificacionActu = state.datosConsultaEspe;
            calificacionActu[clave] = valor;
            return{
                datosConsultaEspe: calificacionActu,
            };
        });
    }

    async manejarEnvioCalificacion(e){
        e.preventDefault();
        if(this.state.datosConsultaEspe.numeroFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar un número de funcionario!',
            })
        }else if(this.state.datosConsultaEspe.nombreFuncionario === ''){
            this.setState({
                errores: 'Debe ingresar un número de funcionario valido!',
            })
        }else if(this.state.datosConsultaEspe.comentarios === ''){
            this.setState({
                errores: 'Debe ingresar un comentario sobre el desempeño del funcionario!',
            })
        }else if((this.state.datosConsultaEspe.escalafon === '')){
            this.setState({
                errores: 'Debe indicar el escalafon!',
            })
        }else if((this.state.datosConsultaEspe.grado === '')){
            this.setState({
                errores: 'Debe indicar el grado!',
            })
        }else if((this.state.datosConsultaEspe.cargo === '')){
            this.setState({
                errores: 'Debe indicar el cargo!',
            })
        }else if((this.state.datosConsultaEspe.serie === '')){
            this.setState({
                errores: 'Debe indicar el serie!',
            })
        }else if((this.state.datosConsultaEspe.lugar === '')){
            this.setState({
                errores: 'Debe indicar el lugar!',
            })
        }else if((this.state.datosConsultaEspe.lugar === '0') && (this.state.datosConsultaEspe.lugarCentral === '')){
            this.setState({
                errores: 'Debe indicar el sector!',
            })
        }else if((this.state.datosConsultaEspe.conSupervision === '')){
            this.setState({
                errores: 'Debe indicar si tiene gente a cargo o no!',
            })
        }else if((this.state.datosConsultaEspe.cantidadTrabajo === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para la cantidad de trabajo!',
            })
        }else if((this.state.datosConsultaEspe.calidadLaboral === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para la calidad de la labor realizada!',
            })
        }else if((this.state.datosConsultaEspe.preocupacionServicio === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 por la preocupación por el servicio o usuario!',
            })
        }else if((this.state.datosConsultaEspe.conocimientoTrabajo === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para el conocimiento del trabajo!',
            })
        }else if((this.state.datosConsultaEspe.interesTrabajo === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para el interés por el trabajo!',
            })
        }else if((this.state.datosConsultaEspe.capacidadTrabajo === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para la capacidad para realizar trabajos en grupo!',
            })
        }else if((this.state.datosConsultaEspe.relacionesInterpersonales === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para las relaciones interpersonales!',
            })
        }else if((this.state.datosConsultaEspe.asistenciaPuntualidad === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para la asistencia y puntualidad!',
            })
        }else if((this.state.datosConsultaEspe.cumplimientoNormas === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para el cumplimiento de normas e instrucciones!',
            })
        }else if((this.state.datosConsultaEspe.supervision === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para la supervisión!',
            })
        }else if((this.state.datosConsultaEspe.logroMetas === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para los logros y metas!',
            })
        }else if((this.state.datosConsultaEspe.iniciativa === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para la iniciativa!',
            })
        }else if((this.state.datosConsultaEspe.compromiso === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para el compromiso!',
            })
        }else if((this.state.datosConsultaEspe.responsabilidad === '')){
            this.setState({
                errores: 'Debe ingresar un puntaje entre 1 y 5 para la responsabilidad!',
            })
        }else{
            const cargaUtil = JSON.stringify([this.state.datosConsultaEspe, 1, sessionStorage.numeroFuncionarioAsociado]);

            const control = await fetch(`${Constantes.RUTA_API}/guardar_calificacionJefe.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res,
            });
            if(res === 'ok'){

                const cargaUtil = JSON.stringify([this.state.consultaCalificacion, sessionStorage.lugar, sessionStorage.lugarCentral, sessionStorage.numeroFuncionarioAsociado]);
                const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_calificacionesJefes.php`,{
                    method: 'POST',
                    body: cargaUtil,
                })
    
                const exito = await respuesta.json();
    
                this.setState({
                    errores: exito[0],
                    loading: false,
                })
                if(exito[0] === 'ok'){
                    this.setState({
                        datosConsulta: exito[1],
                        consultaRealizada: true,
                        errores: null,
                        notificaciones: 'La calificación fue agregada con exito!',
                        datosConsultaEspe:{},
                        consultaEspecifica: false,
                    })
                }
            }
        }
    }
}

export default ConsultaCalificaciones